import React from "react";

import { useAuth } from "../../../../utils/AuthContext";
import AuthenticatedCart from "../../../../features/userDashboard/cart/AuthenticatedCart";
import GuestCart from "../../../../features/userDashboard/cart/GuestCart";
import Dashboard from "../../Dashboard";

function Cart() {
  const { isLoggedIn } = useAuth();

  if (isLoggedIn) {
    return (
      <Dashboard>
        <AuthenticatedCart />
      </Dashboard>
    );
  }

  return <GuestCart />;
}

export default Cart;
